import { Button, notification } from "antd";
import { getMainSearchResult, searchByName, startSearching, updateSearch } from "api/search.api";
import { notificationController } from "components/Common/Notification/Notification";

import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useParams, useSearchParams } from "react-router-dom";
import {
  doCancelSearch,
  setActiveStep,
  setProcessingSearchId,
  setSearchStatus,
} from "store/slices/searcSlice";
import { RootState } from "store/store";
const win: any = window;
win.graph_search_id = null;
interface Prop {
  onCounterChange?: any;
  onSearchStatusChange?: any;
  onGraphIdReceived?: any;
  isModal?: any;
  onSearch?: any;
  isFilterQuery?: boolean;
  isSmall?: boolean;
  setIsSearchLoading?: any;
  runFrom?: string;
}
const SearchInitiatorFilter: React.FC<Prop> = ({
  onCounterChange,
  onSearchStatusChange,
  onGraphIdReceived,
  isModal,
  onSearch,
  isFilterQuery,
  isSmall,
  setIsSearchLoading,
  runFrom,
}) => {
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const Full = useSelector((state: RootState) => state.search.search_name);
  const jobTitle = useSelector((state: RootState) => state.search.job_titles);
  const defaultSelectedProject = useAppSelector((state) => state.search.selectedProject);
  const [count, setCount] = useState(0);
  const [searchingLoading, setSearchingLoading] = useState<any>(false);
  const [graphId, setGraphId] = useState<any>(null);
  const processSearchId = useAppSelector((state) => state.search.processing_search_id);
  const roleId = useAppSelector((state) => state.search.selectedProject?.id);
  const jobTitlesData = useAppSelector((state) => state.search.job_titles);
  const locationsData = useAppSelector((state) => state.search.locations);
  const locationRadius = useAppSelector((state) => state.search.location_radius);
  const search_name: any = useAppSelector((state) => state.search.search_name);
  const minExp = useAppSelector((state) => state.search.min_exp);
  const maxExp = useAppSelector((state) => state.search.max_exp);
  const skillsData = useAppSelector((state) => state.search.skills);
  const universitiesData = useAppSelector((state) => state.search.universities);
  const industryData = useAppSelector((state) => state.search.industries);
  const agencies = useAppSelector((state) => state.search.agencies);
  const agencyParent = useAppSelector((state) => state.search.agency_parents);
  const agencyType = useAppSelector((state) => state.search.agency_types);
  const industryType = useAppSelector((state) => state.search.industry_type);
  const industryLeaders = useAppSelector((state) => state.search.industry_leaders);
  const everWorked = useAppSelector((state) => state.search.ever_worked);

  const industrySegment = useAppSelector((state) => state.search.segments);

  const schoolGroups = useAppSelector((state) => state.search.school_groups);
  const keywords = useAppSelector((state) => state.search.keywords);
  const tied_to_role = useAppSelector((state) => state.search.tied_to_role);
  const exact_job_title_match = useAppSelector((state) => state.search.exact_job_title_match);
  const must_have_keywords = useAppSelector((state) => state.search.must_have_keywords);
  const search_only_greenhouse_mckinney = useAppSelector(
    (state) => state.search.search_only_greenhouse_mckinney
  );
  const search_only_lever_ss = useAppSelector((state) => state.search.search_only_lever_ss);
  const searchFullName = useSelector((state: any) => state.search.full_name);
  const education_fields = useAppSelector((state) => state.search.education_fields);
  const education_levels = useAppSelector((state) => state.search.education_levels);
  const full_name = useAppSelector((state) => state.search.full_name);
  const [searchParams, setSearchParams] = useSearchParams();
  const params = useParams();
  const searchId: any = searchParams.get("searchId") ? searchParams.get("searchId") : 0;
  const graphSearchId: any = params.graphSearchId;
  const worked_previously_at_companies = useAppSelector(
    (state) => state.search.worked_previously_at_companies
  );
  const allow_previous_job_titles = useAppSelector(
    (state) => state.search.allow_previous_job_titles
  );
  const include_subsidiaries = useAppSelector((state) => state.search.include_subsidiaries);
  const exclude_subsidiaries = useAppSelector((state) => state.search.exclude_subsidiaries);
  const exclude_years = useAppSelector((state) => state.search.exclude_years);
  const excludedLocations = useAppSelector((state) => state.search.exclude_locations);

  const candidateWorkData = useAppSelector((state) => state.search.company);
  const excludeData = useAppSelector((state) => state.search.exclude_company);

  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    if (roleId && jobTitlesData && jobTitlesData.length) return;
    setOpen(newOpen);
  };

  const stopSearching = () => {
    const win: any = window;
    if (win["axiosAbort"]) win["axiosAbort"].abort();

    setSearchingLoading(false);
    onSearchStatusChange && onSearchStatusChange("end");
    dispatch(setSearchStatus("end"));
    setCount(0);
    return;
  };

  const handleStopSearch = () => {
    dispatch(doCancelSearch(processSearchId));
  };

  const location = useLocation();

  const handleNavigation = (path: string) => {
    const currentUrl = new URL(window.location.href);
    const newUrl = new URL(path, window.location.origin);

    const currentPathname = currentUrl.pathname;
    const newPathname = newUrl.pathname;

    if (currentPathname === newPathname) {
      // Remove `job-id` and `searchId` from the URL
      const params = new URLSearchParams(currentUrl.search);
      params.delete("job-id");
      params.delete("searchId");

      // Update URL without navigating
      window.history.replaceState(null, "", `${currentPathname}?${params.toString()}`);

      // Reload the page
      window.location.reload();
    } else {
      navigate(path);
    }
  };
  useEffect(() => {
    if (!isNamedSearch) {
      if (!processSearchId) {
        stopSearching();
        return;
      }
      const controller = new AbortController();
      const win: any = window;
      delete win["axiosAbort"];
      win["axiosAbort"] = controller;
      getMainSearchResult(processSearchId)
        .then((data: any) => {
          if (data.count) {
            handleNavigation(
              "/search/search-result/" +
                processSearchId +
                "/" +
                win.graph_search_id +
                "?search_id=" +
                win.graph_search_id +
                "&roleId=" +
                roleId
            );
            dispatch(setActiveStep(0));
            dispatch(setProcessingSearchId(null));
          } else {
            if (count < 300 && processSearchId) {
              onSearchStatusChange && onSearchStatusChange("pending");
              dispatch(setSearchStatus("pending"));
              setCount((count) => {
                onCounterChange && onCounterChange(count + 1);
                return count + 1;
              });
            } else {
              api.error({
                message:
                  "Oops! It looks like you need to adjust your search criteria to deliver better matches.",
              });
              dispatch(setProcessingSearchId(null));
              if (processSearchId) console.log("Search Result issue");
            }
          }
        })
        .catch((e) => {
          onCounterChange && onCounterChange(300);
          api.error({
            message: "Something went wrong while searching candidate",
          });
          dispatch(setProcessingSearchId(null));
          if (processSearchId) console.log("Search Result issue");
        });
    }
  }, [count, processSearchId]);

  const getSearchParam = () => {
    const finalData: any = {
      search_title: search_name
        ? search_name
        : jobTitlesData && jobTitlesData.length
        ? jobTitlesData[0]
        : "No Title",
      skills: skillsData,
      job_title: jobTitlesData,
      run_from: runFrom ?? "Filters",
      min_experience: minExp,
      max_experience: maxExp,
      company: candidateWorkData,
      companies_excluded: excludeData,
      allow_previous_companies: worked_previously_at_companies,
      allow_previous_job_titles: allow_previous_job_titles,

      include_subsidiaries: include_subsidiaries,
      exclude_subsidiaries: exclude_subsidiaries,
      exclude_years: exclude_years,
      // company_groups: industryType,
      company_groups: industrySegment,
      school_groups: schoolGroups,
      locations: locationsData,
      location_radius: locationRadius,
      locations_excluded: excludedLocations,
      allow_previous_locations: false,
      // industries: industryData,
      industries: industryType,
      search_id: graphSearchId ? graphSearchId : 0,
      update_search: graphSearchId ? true : false,
      keywords: keywords,

      education_levels: education_levels,
      ever_worked: everWorked,
      education_fields: education_fields,

      tied_to_role: tied_to_role,
      exact_job_title_match: exact_job_title_match,
      search_only_greenhouse_mckinney: search_only_greenhouse_mckinney,
      search_only_lever_ss: search_only_lever_ss,
      agency_tree: {
        selected_agencies: agencies,
        selected_groups: agencyParent,
        selected_types: agencyType,
      },
      search_wizard_config: {
        worked_previously_at_companies: worked_previously_at_companies,
        allow_previous_job_titles: allow_previous_job_titles,
        include_subsidiaries: include_subsidiaries,
        exclude_subsidiaries: exclude_subsidiaries,
        exclude_years: exclude_years,
        // companyGroups: industryType,
        companyGroups: industrySegment,
        school_groups: schoolGroups,
        locations: locationsData,
        company: candidateWorkData,
        companies_exclude: excludeData,
        agencies: agencies,
        agencyParent: agencyParent,
        agencyType: agencyType,
        locations_exclude: excludedLocations,
        location_radius: locationRadius,
        keywords: keywords,
        ever_worked: everWorked,

        job_title: jobTitlesData,
        // industries: industryData,
        industries: industryType,
        universities: universitiesData,
        skills: skillsData,
        minExp: minExp,
        maxExp: maxExp,
        education_levels: education_levels,
        education_fields: education_fields,
        tied_to_role: tied_to_role,
        exact_job_title_match: exact_job_title_match,
      },
      job: roleId,

      must_have_skill: skillsData,
      must_have_keywords: must_have_keywords ? keywords : [],

      parent_search: "",
      universities: universitiesData,
    };
    if (fullName) finalData["full_name"] = fullName;
    if (everWorked == null) {
      // delete finalData["ever_worked"];
      // delete finalData["search_wizard_config"]["ever_worked"];
    }
    return finalData;
  };
  const initiateSearch = () => {
    const searchParam = getSearchParam();
    setSearchingLoading(true);
    // if (
    //   searchParam.search_title.length < 1
    // ) {
    //   api.error({
    //     message: "Please enter search name before initiating the search",
    //   });
    //   return;
    // }
    // if (searchParam.job_title.length < 1 && !isNamedSearch) {
    //   api.error({
    //     message: "Please enter Job title before initiating the search",
    //   });
    //   return;
    // }
    // if (!roleId || !jobTitlesData || jobTitlesData.length === 0)
    //   onSearchStatusChange && onSearchStatusChange("start");
    // dispatch(setSearchStatus("start"));
    // setCount(() => {
    //   return 0;
    // });
    setSearchingLoading(true);

    if (searchId) {
      updateSearch(searchId, getSearchParam()).then(
        (search: any) => {
          dispatch(setProcessingSearchId(search.id));
          onGraphIdReceived && onGraphIdReceived(search.graph_search_id);
          win.graph_search_id = search.graph_search_id;
          setGraphId(search.graph_search_id);
          // dispatch(setProcessingSearchId(search.search_id));
          // notificationController.success({
          //   message: "Searching initiated successfully.",
          // });

          //onStepChange(currentStep + 1);
        },
        (err: any) => {
          // dispatch(removeProcessingSearchId(null));
          //
          // setSearchingLoading(false);
          api.error({ message: err.message.toString() });
        }
      );
    } else {
      startSearching(getSearchParam()).then(
        (search: any) => {
          dispatch(setProcessingSearchId(search.id));
          onGraphIdReceived && onGraphIdReceived(search.graph_search_id);
          win.graph_search_id = search.graph_search_id;
          setGraphId(search.graph_search_id);
          // dispatch(setProcessingSearchId(search.search_id));
          // notificationController.success({
          //   message: "Searching initiated successfully.",
          // });

          //onStepChange(currentStep + 1);
        },
        (err: any) => {
          // dispatch(removeProcessingSearchId(null));
          // setSearchingLoading(false);
          api.error({ message: err.message.toString() });
        }
      );
    }
  };
  useEffect(() => {
    setIsSearchLoading && setIsSearchLoading(searchingLoading);
  }, [searchingLoading]);

  const [namedSearchId, setNamedSearchId] = useState<any>(null);
  const [namedGraphSearchId, setNamedGraphSearchId] = useState<any>(null);
  const [seconds, setSeconds] = useState(0);
  const isNamedSearch = useSelector((state: any) => state.search.isNamedSearch);
  const fullName = useSelector((state: any) => state.search.full_name);

  const searchByNameResult = () => {
    setSearchingLoading(true);
    searchByName(
      {
        full_name: fullName,
        locations: locationsData,
        run_from: runFrom ?? "Filters",
      },
      getSearchParam().search_wizard_config,

      roleId
    ).then((data: any) => {
      //setSeconds(1);
      setNamedSearchId(data.id);
      dispatch(setProcessingSearchId(data.id));
      setNamedGraphSearchId(data.graph_search_id);
      //navigate("/search/search-result/" + data.search_id);

      // {
      //   "/search/search-result/" + searchId + "/" + search_id;
      // }
    });
  };

  useEffect(() => {
    if (isNamedSearch) {
      if (!processSearchId) {
        stopSearching();
        return;
      }
      if (seconds <= 20 && namedSearchId) {
        setSearchingLoading(true);
        const interval = setInterval(() => {
          if (seconds > 20) {
            setSearchingLoading(false);
            notificationController.error({
              message: "Sorry, no results were found. Please try different name.",
            });
            setNamedSearchId(null);
            setSeconds(0);
            return () => clearInterval(interval);
          }
          getMainSearchResult(namedSearchId).then((data: any) => {
            if (data.count) {
              navigate("/search/search-result/" + namedSearchId + "/" + namedGraphSearchId);
              setSeconds(20);
              dispatch(setActiveStep(0));
              dispatch(setProcessingSearchId(null));
            } else {
              setSeconds(seconds + 1);
            }
          });

          // if (seconds > 100) {
          //   setSeconds(100);
          //   setSearchingLoading(false);
          // }
        }, 1000);
        return () => clearInterval(interval);
      } else {
        setSearchingLoading(false);
        return;
      }
    }
  }, [seconds, namedSearchId, processSearchId]);

  return (
    <>
      {contextHolder}
      <Button
        onClick={() => {
          isModal && isNamedSearch
            ? searchByNameResult()
            : isModal && onSearch && !isFilterQuery
            ? onSearch()
            : initiateSearch();
        }}
        disabled={isNamedSearch && !searchFullName}
        loading={searchingLoading}
        size={isSmall ? "small" : "middle"}
        // icon={<FilterOutlined></FilterOutlined>}
        className="big-search-btn bg-primary text-white"
      >
        {searchId ? "Update Search" : "Run Your Search"}
      </Button>
      {searchingLoading && (
        <Button
          size={isSmall ? "small" : "middle"}
          onClick={handleStopSearch}
          type="default"
          className="ml-2"
        >
          Cancel
        </Button>
      )}
    </>
  );
};
export default SearchInitiatorFilter;
